export default "__VITE_ASSET__cf0d2736__"